import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import {
  SOCIAL_PROOF_SETTINGS_KEY,
  defaultSocialProofConfig,
  mergeSocialProofConfig,
  type SocialProofConfig,
} from "@/config/socialProof";

export const fetchSocialProofConfig = async (): Promise<SocialProofConfig> => {
  const { data } = await supabase
    .from("site_settings")
    .select("value")
    .eq("key", SOCIAL_PROOF_SETTINGS_KEY)
    .maybeSingle();
  return mergeSocialProofConfig(data?.value);
};

export const saveSocialProofConfig = async (config: SocialProofConfig) => {
  const { error } = await supabase.from("site_settings").upsert({
    key: SOCIAL_PROOF_SETTINGS_KEY,
    value: config as never,
    updated_at: new Date().toISOString(),
  });
  if (error) throw error;
};

export const useSocialProofConfig = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["social-proof-config"],
    queryFn: fetchSocialProofConfig,
    staleTime: 60_000,
  });

  return { config: data ?? defaultSocialProofConfig(), loading: isLoading, refetch };
};
